import AppCrashReportTable from "@/components/Templates/AppCrashReport/AppCrashReportTable/AppCrashReportTable";
import AppCrashReportOverview from "../AppCrashReportOverview/AppCrashReportOverview";

const AppCrashReports = () => {
  return (
    <>
      <AppCrashReportOverview />
      <AppCrashReportTable />
    </>
  );
};

export default AppCrashReports;